import { AuthCRUD, AuthLayoutProps, AuthStorage, LayoutProps, PageAuth } from "@/components/layout/layoutType";
import { Debug } from "./debug";
import { fetchHost } from "./fetchutil";
import dv from "@datas/default.json";
import { DataColumn } from "@/components/layout/input/inputType";
import { UNDERSCORE_NOT_FOUND_ROUTE } from "next/dist/shared/lib/constants";

type CheckType = "menu" | "list" | "read" | "create" | "update" | "delete";
type LinkType = "menu" | "listview" | "view" | "write" | "edit" | "remove";
const check_auth_type: CheckType[] = ["menu", "list", "read", "create", "update", "delete"];
const check_auth_link: Record<CheckType, LinkType> = {
  menu: "menu",
  list: "listview",
  read: "view",
  create: "write",
  update: "edit",
  delete: "remove",
};

export const checkUserPageAuth = (
  usertype: string[] | undefined,
  userAuth: AuthLayoutProps,
  item: any,
  onlylist?: boolean
): PageAuth => {
  const pageAuth = item.auth as Record<string, AuthCRUD>;
  //   Debug(userAuth);
  //   Debug(pageAuth);
  if (pageAuth) {
    //소속별 권한이 필요한 경우
    if (userAuth && userAuth !== "loading") {
      //권한이 있고 로딩중이 아닌 경우
      const userPageAuth: PageAuth = { write: true, view: true, edit: true, remove: true, listview: true, menu: true };
      if (!onlylist) {
        userPageAuth.userAuth = {};
      }
      Object.keys(pageAuth).forEach((key) => {
        if (userAuth[key] && userAuth[key].select) {
          const user_auth_list = userAuth[key].list;
          const temp_user_auth = userAuth[key].select.user_auth;
          if (userPageAuth.userAuth) {
            userPageAuth.userAuth[key] = { seq: userAuth[key].select.auth_seq, usertype: temp_user_auth };
          }
          const temp_page_auth = pageAuth[key];
          check_auth_type.forEach((temp_type) => {
            const menu_or_list = temp_type === "menu" || temp_type === "list";
            const temp_auth_link = check_auth_link[temp_type];
            const temp_page_auth_type = temp_page_auth[temp_type];
            if (menu_or_list || !onlylist) {
              if (
                (menu_or_list && temp_page_auth_type && !temp_page_auth_type.includes(temp_user_auth)) ||
                (!menu_or_list &&
                  (!temp_page_auth_type || (temp_page_auth_type && !temp_page_auth_type.includes(temp_user_auth))))
              ) {
                userPageAuth[temp_auth_link] = false;
              }

              if (!userPageAuth[temp_auth_link]) {
                if (user_auth_list && temp_page_auth_type) {
                  temp_page_auth_type.forEach((item) => {
                    if (typeof item !== "string") {
                      const item_user_type =
                        item.user_type instanceof Array
                          ? item.user_type
                          : typeof item.user_type === "string"
                          ? [item.user_type]
                          : undefined;
                      if (
                        (item.minCount !== undefined || item.maxCount !== undefined) &&
                        (item_user_type === undefined ||
                          (usertype &&
                            item_user_type &&
                            item_user_type.some((temp_user_type) => usertype.includes(temp_user_type))))
                      ) {
                        const check_type = item.type;
                        const filter_list = user_auth_list.filter((temp_auth) => {
                          return temp_auth.user_auth === check_type;
                        });
                        //Debug(filter_list);
                        if (
                          (item.minCount === undefined ||
                            (item.minCount !== undefined && filter_list.length > item.minCount)) &&
                          (item.maxCount === undefined ||
                            (item.maxCount !== undefined && filter_list.length < item.maxCount))
                        ) {
                          userPageAuth[temp_auth_link] = true;
                        }
                      }
                    }
                  });
                }
              }
            }
          });
        } else {
          userPageAuth.listview = false;
          userPageAuth.menu = false;
          userPageAuth.view = false;
          userPageAuth.write = false;
          userPageAuth.edit = false;
          userPageAuth.remove = false;
        }
      });
      return userPageAuth;
    } else {
      // Debug("userAuth is null", item);
      // Debug(pageAuth);
      if (userAuth === "loading") {
        const menu = checkUsertypeCRUD(usertype, item.menu);
        const check_menu = pageAuth
          ? Object.keys(pageAuth).some((item) => {
              const temp_menu = pageAuth[item].menu;
              if (temp_menu) {
                const guest = temp_menu.includes("GUEST");
                const condition = temp_menu.some((temp_auth) => {
                  return typeof temp_auth !== "string";
                });
                return !(guest && !condition);
              }
              return false;
            })
          : true;
        return {
          write: false,
          view: false,
          edit: false,
          remove: false,
          listview: true,
          menu: menu && !check_menu,
        };
      }
      const result = { write: false, view: false, edit: false, remove: false, listview: false, menu: true };
      Object.keys(pageAuth).forEach((key) => {
        const key_auth = pageAuth[key];
        if (key_auth.create && key_auth.create.includes("GUEST")) {
          result.write = onlylist ? false : checkUsertypeCRUD(usertype, item.create, false);
        }
        if (key_auth.read && key_auth.read.includes("GUEST")) {
          result.view = onlylist ? false : checkUsertypeCRUD(usertype, item.read, false);
        }
        if (key_auth.update && key_auth.update.includes("GUEST")) {
          result.edit = onlylist ? false : checkUsertypeCRUD(usertype, item.update, false);
        }
        if (key_auth.delete && key_auth.delete.includes("GUEST")) {
          result.remove = onlylist ? false : checkUsertypeCRUD(usertype, item.delete, false);
        }
        if (key_auth.list && key_auth.list.includes("GUEST")) {
          result.listview = checkUsertypeCRUD(usertype, item.list);
        }

        if (key_auth.menu) {
          if (key_auth.menu.includes("GUEST")) {
            result.menu = checkUsertypeCRUD(usertype, item.menu);
          } else {
            result.menu = false;
          }
        }
      });
      return result;
    }
  } else {
    //소속별 권한이 필요 없는 경우
    return {
      write: onlylist ? false : checkUsertypeCRUD(usertype, item.create, false),
      view: onlylist ? false : checkUsertypeCRUD(usertype, item.read),
      edit: onlylist ? false : checkUsertypeCRUD(usertype, item.update, false),
      remove: onlylist ? false : checkUsertypeCRUD(usertype, item.delete, false),
      listview: checkUsertypeCRUD(usertype, item.list),
      menu: checkUsertypeCRUD(usertype, item.menu),
    };
  }
};
export const checkUsertypeCRUD = (
  usertype: string[] | undefined,
  list: string[] | undefined,
  dv?: boolean
): boolean => {
  // Debug(usertype, list);
  if (list) {
    if (usertype) {
      return usertype.some((item) => {
        return list.includes(item);
      });
    } else {
      return list.includes("GUEST") ? true : false;
    }
  } else {
    return dv ?? true;
  }
};
export const getSelectPageUserAuth = (params: LayoutProps | undefined, key: string) => {
  const user_auth = params?.auth instanceof Object ? params?.auth[key] : undefined;
  if (user_auth) {
    return user_auth.select;
  } else {
    return undefined;
  }
};
export const getUserAuthSelect = (pageAuth?: Record<string, any> | null) => {
  if (pageAuth) {
    const select: Record<string, number> = {};
    Object.keys(pageAuth).forEach((key) => {
      const temp_auth_session = getUserAuthSession(key);
      if (temp_auth_session) {
        if (temp_auth_session.select !== null && temp_auth_session.select !== undefined) {
          select[key] = temp_auth_session.select;
        } else if (temp_auth_session.list && temp_auth_session.list.length > 0) {
          select[key] = temp_auth_session.list[0].auth_seq;
        }
      }
    });
    if (Object.keys(select).length > 0) {
      return select;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export const getUserAuthSessionStr = (key: string) => {
  try {
    if (sessionStorage !== undefined) {
      return sessionStorage.getItem(key + "_auth");
    }
  } catch (e) {
    return null;
  }
  return null;
};

export const getUserAuthSession = (key: string) => {
  const temp_auth_str = getUserAuthSessionStr(key);
  if (temp_auth_str) {
    try {
      return JSON.parse(temp_auth_str) as AuthStorage;
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const getUserAuthSessions = (auth?: any) => {
  const temp_auth = auth ? (auth as Record<string, any>) : undefined;
  if (temp_auth) {
    const total_auth: Record<string, AuthStorage> = {};
    try {
      if (sessionStorage !== undefined) {
        Object.keys(temp_auth).forEach((key) => {
          const temp_auth_str = sessionStorage.getItem(key + "_auth");
          if (temp_auth_str) {
            total_auth[key] = JSON.parse(temp_auth_str) as AuthStorage;
          }
        });
      }
    } catch (e) {}
    if (Object.keys(total_auth).length > 0) {
      return total_auth;
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
};

export const addUserAuthSelect = (obj: any, pageAuth: Record<string, any>) => {
  const select = getUserAuthSelect(pageAuth);
  if (select) {
    Object.keys(select).forEach((key) => {
      obj[key + "_seq"] = select[key];
    });
  }
};
export const changeUserAuthSelect = (key: string, select: number) => {
  try {
    if (sessionStorage !== undefined) {
      const temp_auth_str = sessionStorage.getItem(key + "_auth");
      if (temp_auth_str) {
        const select_auth = JSON.parse(temp_auth_str) as AuthStorage;
        if (select_auth.list) {
          const filter = select_auth.list.filter((item) => item.auth_seq);
          if (filter.length > 0) {
            select_auth.select = select;
            sessionStorage.setItem(key + "_auth", JSON.stringify(select_auth));
            return true;
          }
        }
      }
    }
  } catch (e) {}
  return false;
};

export const getUserAuthData = (
  auth_list: string[],
  userseq?: number,
  user_auth?: Record<string, AuthStorage>,
  now?: Date,
  complete?: Function
) => {
  if (userseq) {
    fetchHost(
      "/api/userAuth/select",
      {
        ...dv.fetchOption,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ auth: auth_list }),
      },
      undefined,
      (data: any) => {
        //Debug(data);
        const result = data.result;
        if (result === undefined) {
          if (data.status === "401") {
            location.reload();
          }
          return;
        }
        Debug(user_auth, data, result);
        const temp_user_auth = user_auth ?? {};
        const temp_now = now ?? new Date();
        let change = false;
        auth_list.forEach((key) => {
          let temp_auth_str: string | undefined = undefined;
          if (!user_auth) {
            const temp_auth = getUserAuthSession(key);
            if (temp_auth) {
              temp_auth_str = JSON.stringify(temp_auth);
              temp_user_auth[key] = temp_auth;
            }
          }
          const temp_data = result[key + "_auth"];
          const prev_select =
            temp_user_auth[key] && temp_user_auth[key].select
              ? temp_user_auth[key].select
              : temp_data && temp_data.length > 0 && temp_data[0].auth_seq
              ? temp_data[0].auth_seq
              : undefined;
          if (temp_user_auth[key] !== undefined) {
            delete temp_user_auth[key].select;
            temp_user_auth[key].access_at = temp_now.toISOString();
          }
          const change_auth = {
            user: userseq,
            name: key,
            list: temp_data,
            access_at: temp_now.toISOString(),
          };
          if (!change && JSON.stringify(change_auth) !== JSON.stringify(temp_user_auth[key])) {
            change = true;
          }
          if (user_auth) {
            user_auth[key] = { ...change_auth, select: prev_select };
          } else {
            temp_user_auth[key] = { ...change_auth, select: prev_select };
          }
          if (sessionStorage !== undefined) {
            sessionStorage.setItem(key + "_auth", JSON.stringify(user_auth ? user_auth[key] : temp_user_auth[key]));
          }
        });
        if (complete) {
          complete({ change, result });
        }
      },
      (e: any) => {
        // Debug("getUserAuthData", e);
      }
    );
  }
};
